// extracted by mini-css-extract-plugin
export default {"island":"island__dIUGA","__disable-top-corners":"__disable-top-corners__xjoo4","__disable-bottom-corners":"__disable-bottom-corners__vJg8P"};